module.exports = __webpack_public_path__ + "a351358a1fecd007614a156df49cb1a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/znk.png
// module id = 1581
// module chunks = 0